import { FormControl, Grid } from '@mui/material'
import { CustomAutocomplete } from 'common'
import React from 'react'

export const FieldContract = (props) => {

    const {
        formState,
        handleChangeContract,
        FetchData,
        readOnly
    } = props

    const { fetchAllContracts } =FetchData
    const { contracts } = fetchAllContracts

    return (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="Contract"> * Contrato</label>
                    <CustomAutocomplete 
                        customId="idcontrato"
                        customName="idcontrato"
                        customValue={formState.idcontrato}
                        customOnChange={(target, value) => handleChangeContract({ target: { name: 'idcontrato', value: value.value }  })}
                        customPlaceholder='Selecciona un contrato'
                        customOptions={
                            contracts.map(({ idcontrato, contrato_codigo, datos_cliente }) => ({
                                value: idcontrato,
                                name: `${contrato_codigo} - ${datos_cliente}`
                            }))
                        }
                        customDisableClearable={true}
                        customDisabled={(readOnly)}
                    />
                </FormControl>
            </Grid>
        </Grid>
    )
}
